import(/* webpackMode: "eager", webpackExports: ["PopularPageClient"] */ "/app/src/app/[locale]/popular/page.client.tsx");
